import * as React from 'react';
import * as E from '@chehejia/wangeditor';
import { Modal, Button, Input } from 'antd';
import { inject } from 'mobx-react';
import { WithBaiduMediaUpload } from '../HOC/BaiduMediaUpload';
import './index.scss';
@WithBaiduMediaUpload(inject('store'))
export default class Editor extends React.PureComponent<any, any> {
    public editorElem;
    public editor;
    constructor(props) {
        super(props);
        this.state = {
            isImageLinkVisible: false,
            currImgeObj: '',
            currEl: null,
            scrollY: null
        };
    }
    public componentWillReceiveProps(nextProps) {
        const oldCon = this.props.editorContent.replace(/\s+/g, '');
        const newCon = nextProps.editorContent.replace(/\s+/g, '');
        if (oldCon !== newCon) {
            if (
                this.props.editorContent === '<p><br></p>' ||
                this.props.editorContent === ''
            ) {
                this.editor && this.editor.txt.html(nextProps.editorContent);
            } else if (nextProps.editorContent === '<p><br></p>') {
                this.editor && this.editor.txt.html(nextProps.editorContent);
            }
            if (this.editor) {
                let editorText = this.editor.txt.text().replace(/&nbsp;/gi, '');
                editorText = editorText.replace(
                    '更换封面图视频尚未发布，暂时无法播放',
                    ''
                );
                editorText = editorText.replace(/\s+/g, '');
                this.props.setStates({
                    editorContentLength: editorText.length
                });
            }
        }
    }
    public componentDidMount() {
        document.title = '文本编辑器';
        const elem = this.editorElem;
        this.editor = new E(elem);
        // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
        this.editor.customConfig.onchange = html => {
            let editorText = this.editor.txt.text().replace(/&nbsp;/gi, '');
            editorText = editorText.replace(
                '更换封面图视频尚未发布，暂时无法播放',
                ''
            );
            editorText = editorText.replace(/\s+/g, '');
            console.log(this.editor.$textElem[0].innerHTML,'文章内容变化')
            this.props.setStates({
                editorContent: this.editor.$textElem[0].innerHTML || html,
                editorContentLength: editorText.length
            });
        };
        this.editor.customConfig.menus = [
            'image', // 插入图片
            'video', // 插入视频
            'head', // 标题
            'bold', // 粗体
            'link', // 插入链接
            'splitHr', // 分割线
            'fullScreen', // 全屏
            'quote' // 引用
        ];
        this.editor.customConfig.uploadImgServer = this.props.getStsWrite;
        this.editor.customConfig.uploadImgHooks = {
            customInsert(result) {
                // editor.cmd.do('insertHTML', '<p><br></p><p  style="width:100%;text-align:center;"><img src="' + url + '" alt="" style="max-width: 80%;max-height:80%;" /><br></p>');
                // insertImg(url);
            }
        };
        this.editor.customConfig.customUploadVideo = this.props.getStsUpload;
        this.editor.customConfig.uploadVideoHooks = {
            customInsert(result, editor) {
                const poster = result.snapshots[0];
                const playURL = result.PlayInfo[0].playURL;
                const pixel = result.pixel;
                // editor.cmd.do('insertHTML', '<p><br></p><p  style="width:100%;text-align:center;"><video class="' + result.videoId + '" poster="' + poster + '" data-videoId="' + result.videoId + '" src="' + playURL + '" style="max-width: 50%;max-height:50%;" controls autobuffer ></video><br></p>');
                editor.cmd.do(
                    'insertHTML',
                    '<p><br></p><div contenteditable="false" style="display: block;text-align:center;" class="editorVideoBox"><div class="editorVideo">' +
                        '<div class="videoImgCon">' +
                        '<span class="videoClose"></span>' +
                        '<img class="videoBox" src="' +
                        poster +
                        '" data-videoId="' +
                        result.videoId +
                        '" alt="文字视频" data-playUrl="' +
                        playURL +
                        '"  data-pixel="' +
                        pixel +
                        '"/>' +
                        '<div class="cover" contenteditable="false" style="font-size:16px;font-weight: normal;">更换封面图</div>' +
                        '<div class="tip" contenteditable="false" style="font-size:16px;font-weight: normal;">视频尚未发布，暂时无法播放</div>' +
                        '<span class="videoPlay" contenteditable="false"></span>' +
                        '</div>' +
                        '</div></div><br>'
                );
            }
        };

        this.editor.customConfig.zIndex = 1;
        this.editor.customConfig.fixedTop = 0;
        this.editor.customConfig.fixedLeft = '55%';
        this.editor.customConfig.uploadImgMaxLength = 10;
        this.editor.customConfig.showLinkImg = false;
        this.editor.customConfig.uploadImgShowBase64 = true;
        this.editor.create();
    }
    public imgLinkEdit(e) {
      // debugger
        if (e.target.nodeName === 'IMG' && e.target.className !== 'videoBox' ) {
            const currImgeObj = e.target.getAttribute('href');
            this.setState({
                currImgeObj,
                isImageLinkVisible: true,
                currEl: e.target,
                scrollY: window.scrollY
            });
        }
    }
    public addLinkMsgToImg() {
        const { currImgeObj, currEl, scrollY } = this.state;
        if (currImgeObj) {
            currEl.style.borderWidth = '1px';
            currEl.style.borderStyle = 'solid';
            currEl.style.borderColor = '#FF0000';
        } else {
            currEl.style.border = `none`;
        }
        currEl.setAttribute('href', currImgeObj || '');

        this.setState(
            {
                isImageLinkVisible: false,
                currImgeObj: '',
                currEl: null,
                scrollY: 0
            },
            () => {
                window.scrollTo(0, scrollY);
                // 更新编辑器props内容
                // console.log(this.editor.$textElem[0].innerHTML,'文章编辑内容')
                this.props.setStates({
                  editorContent: this.editor.$textElem[0].innerHTML
                });
            }
        );
    }
    public cancelLinkMsgToImg() {
        const { scrollY } = this.state;

        this.setState(
            {
                isImageLinkVisible: false,
                currImgeObj: '',
                currEl: null
            },
            () => {
                window.scrollTo(0, scrollY);
            }
        );
    }
    public render() {
        const { textareaArticleBoxZIndex, hasFixdEditor } = this.props;
        const { isImageLinkVisible, currImgeObj } = this.state;
        return (
            <React.Fragment>
                <div
                    className="textareaArticleBox"
                    ref={ref => (this.editorElem = ref)}
                    onClick={e => {
                        this.imgLinkEdit(e);
                    }}
                    style={
                        hasFixdEditor
                            ? {
                                  textAlign: 'left',
                                  position: 'fixed',
                                  zIndex: 0,
                                  top: '0',
                                  width: '100%',
                                  background: '#fff',
                                  left: 0
                              }
                            : textareaArticleBoxZIndex
                            ? {
                                  textAlign: 'left',
                                  position: 'relative',
                                  zIndex: -1
                              }
                            : {
                                  textAlign: 'left',
                                  position: 'relative',
                                  zIndex: 0
                              }
                    }></div>
                <Modal
                    title="请编辑图片超链接"
                    visible={isImageLinkVisible}
                    onOk={this.addLinkMsgToImg.bind(this)}
                    onCancel={this.cancelLinkMsgToImg.bind(this)}>
                    <div className="img-link-modal">
                        <span className="label-name">跳转链接：</span>
                        <Input
                            type="text"
                            value={currImgeObj}
                            placeholder="请编辑超链接"
                            onChange={e => {
                                this.setState({
                                    currImgeObj: e.target.value
                                });
                            }}
                        />
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
